import { Link } from "react-router-dom";
import { fileUrl } from "../lib/api";

export function ProductMarquee({ products, speed = 40 }) {
  if (!products || products.length === 0) return null;
  // duplicate list for seamless loop
  const items = [...products, ...products];
  return (
    <div className="relative overflow-hidden" data-testid="product-marquee">
      <div
        className="marquee-track gap-8 py-4"
        style={{ animationDuration: `${speed}s` }}
      >
        {items.map((p, idx) => (
          <Link
            to={`/products/${p.id}`}
            key={`${p.id}-${idx}`}
            data-testid={`marquee-item-${idx}`}
            className="shrink-0 w-[280px] bg-white border border-border rounded-2xl overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all"
          >
            <div className="aspect-[4/3] bg-muted overflow-hidden">
              <img
                src={fileUrl(p.image_url)}
                alt={p.name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <div className="text-xs uppercase tracking-[0.15em] text-primary font-bold mb-1">
                {p.category}
              </div>
              <div className="font-heading text-lg font-semibold leading-snug line-clamp-2">
                {p.name}
              </div>
              <div className="mt-2 text-secondary font-bold">₹{Number(p.price).toLocaleString("en-IN")}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
